var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14591 4.48039L4.28789 3.65234L4.42986 4.48039C4.69208 6.00975 5.71692 7.20521 7.02801 7.51107L7.73789 7.67668L7.02801 7.84229C5.71692 8.14816 4.69208 9.34361 4.42986 10.873L4.28789 11.701L4.14591 10.873C3.8837 9.34361 2.85886 8.14816 1.54776 7.84229L0.837891 7.67668L1.54776 7.51107C2.85886 7.20521 3.8837 6.00975 4.14591 4.48039Z",
    fill: "#86868B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34151 0.712852L1.4125 0.298828L1.48349 0.712852C1.6146 1.47753 2.12701 2.07525 2.78256 2.22819L3.1375 2.311L2.78256 2.3938C2.12701 2.54673 1.6146 3.14445 1.48349 3.90914L1.4125 4.32317L1.34151 3.90914C1.2104 3.14445 0.697977 2.54673 0.0424358 2.3938L-0.3125 2.311L0.0424358 2.22819C0.697977 2.07525 1.2104 1.47753 1.34151 0.712852Z",
    fill: "#86868B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11537 1.24575L7.16269 0.969727L7.21002 1.24575C7.29742 1.75554 7.63904 2.15401 8.07607 2.25597L8.3127 2.31118L8.07607 2.36638C7.63904 2.46834 7.29742 2.86682 7.21002 3.3766L7.16269 3.65263L7.11537 3.3766C7.02796 2.86682 6.68636 2.46834 6.24932 2.36638L6.0127 2.31118L6.24932 2.25597C6.68636 2.15401 7.02796 1.75554 7.11537 1.24575Z",
    fill: "#86868B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/Ai.06119374021def90a41ea2db6f1cf2db.svg";
export { ForwardRef as ReactComponent };